export default "__VITE_ASSET__BSnZtxW$__"